import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Table from '../../../common/components/table/simple-table';

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
        display:'inline-block',
        color:"#FFFFFF"

    },
    closeIcon:{
        position:'absolute',
        top:10,
        right:10
    },
});

const columns = [
    {name:'FileName',title:'ファイル名'},
    {name:'SlipNumber',title:'登録伝票数'},
    {name:'OKNumber',title:'自動処理ページ数'},
    {name:'ManualNumber',title:'手動登録ページ数'},
    {name:'DeleteNumber',title:'破棄ページ数'},
    {name:'TotalNumber',title:'読み込み合計ページ数'},
];


class complete extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    handleClose = () => {
        if(this.props.afterCloseFunc) this.props.afterCloseFunc();
    };

    render () {
        const { classes,dataSource } = this.props;

        return (
            <div className="over_rays">
                <div className={classes.closeIcon}>
                    <IconButton color={"primary"} className={classes.button} aria-label="CLOSE"
                                onClick={this.handleClose}>
                        <CloseIcon/>
                    </IconButton>
                </div>
                <div className="over_rays_title">取込完了</div>
                <Table
                    dataSource={dataSource}
                    columns={columns}
                    isGrouping={true}
                    groupingColumns={'FileName'}
                    defaultExpandedGroups={['合計']}
                />
            </div>
        );
    }
}
complete.propTypes = {
    dataSource: PropTypes.array,
    afterCloseFunc:PropTypes.func,

};
complete.defaultProps = {
    dataSource: []
};
export default withStyles(styles)(complete);



// WEBPACK FOOTER //
// ./src/routes/upload-receipt/components/complete.js